/** Directory row used to autofill sabil holder name/address from ITS. */
export type ItsDirectoryLookupRow = {
  Full_Name?: string | null;
  Address?: string | null;
};

/**
 * Autofill only when the ITS dump has a row. A miss must not wipe values already
 * on the form (Mutawatteen holders are often absent from the local dump).
 */
export function formFieldsFromItsDirectoryHit(
  row: ItsDirectoryLookupRow | null | undefined
): { name: string; address: string } | null {
  if (!row) {
    return null;
  }
  return {
    name: String(row.Full_Name ?? ""),
    address: String(row.Address ?? ""),
  };
}

/**
 * Skip directory lookup when the field still matches the loaded record (ignoring
 * surrounding whitespace). Re-query only after the ITS number actually changes.
 */
export function shouldLookupItsDirectory(currentIts: unknown, loadedIts: unknown): boolean {
  const current = String(currentIts ?? "").trim();
  if (!current) {
    return false;
  }
  const loaded = String(loadedIts ?? "").trim();
  return !loaded || current !== loaded;
}
